export const normalizeSearch = (value: string): string => value.trim();

export const truncateText = (value: string, length = 140): string => {
  if (!value) {
    return '';
  }
  if (value.length <= length) {
    return value;
  }
  return `${value.slice(0, length - 1)}...`;
};

export const formatDateTime = (value: string): string => {
  try {
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(new Date(value));
  } catch {
    return value;
  }
};

export const formatMetadataValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '�?"';
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

export const buildOptionLabelMap = (
  options: Array<{ value: string; label: string }> | undefined,
): Map<string, string> => {
  if (!Array.isArray(options)) {
    return new Map();
  }
  return new Map(options.map((option) => [option.value, option.label]));
};
